import * as React from "react";
import * as _ from 'lodash';
import makeStyles from "@mui/styles/makeStyles";
import {
    FormControl,
    FormLabel,
    Grid,
    TextField,
    RadioGroup,
    FormControlLabel,
    Radio,
    TextareaAutosize,
    Table, TableBody, TableCell, TableRow, Checkbox, FormGroup, MenuItem, Select, IconButton,
} from "@mui/material";
import {useTranslation} from "react-i18next";
import clsx from "clsx";
import {ToggleRadioNamed} from "./components";
import DatePicker from "@mui/lab/DatePicker";
import config from '../../app/config';
import AgyleToggleButtons from '../../components/ui/buttons/agyleToggleButtons';
import {bookAdmissionToggleStyles} from '../bookedAdmissions/bookedAdmissions';

const useStyles = makeStyles((theme) => ({
    label: {
        color: theme.palette.admissionForm.labelColor,
        lineHeight: "20px",
        fontWeight: "500",
        fontSize: "0.85rem",
        marginBottom: "8px",
    },
    notesInput: {
        backgroundColor: theme.palette.background.paperDarker,
        borderColor: theme.palette.admissionForm.borderColor,
        borderRadius: "6px",
        color: theme.palette.admissionForm.textColor,
        resize: "none",
    },
    noBorder: {
        border: "0px",
        paddingBottom: "6px",
        paddingTop: "6px"
    },
    tableSelect: {
        paddingBottom: "0px"
    },
    hr: {
        height: "3px",
        marginLeft: "-20px",
        marginRight: "-20px",
        marginTop: "22px",
        marginBottom: "12px",
        backgroundColor: theme.palette.background.default
    }
}))

export const basicInformationSchema = {
    phone: "",
    transportType: null, //select
   // ambulanceTransportType: "", //radio select
    priority: null, //select
    anaestheticType: null, //select
    patientType: null, //select
    whoCouldOperate: null, //select
    icuHduBed: false, //checkbox
    firstOnList: false, //checkbox
    patientToStopAspirin: false, //checkbox
    diabetic: false, //checkbox
    radiologySupport: false, //checkbox
    lastOnList: false, //checkbox
    patientToStopContPill: false, //checkbox
    idd: false, //checkbox
    requiresFirstAssistant: false, //checkbox
    amListOnly: false, //checkbox
    patientToStopWafarin: "", //select //patientToStopWafarin
    latexAllergy: false, //checkbox
    specialistEquipment: false, //checkbox //TODO:rename on API!!!!
    pacemakerCheck: false, //checkbox
    requiresBariatricTable: false, //checkbox
    antiCoagulents: "", //select
    breachDate18wk: null, //date
    decisionToTreat: null, //date
    lengthOfStay: "", //select
    mrsaScreen: {
        code: null,
        description: ""
    }
}


export function BasicInformationSection(props) {
    const classes = useStyles();
    const {t} = useTranslation();
    const [admission, setAdmission] = React.useState(_.cloneDeep(basicInformationSchema));
    const dictionaries = props.dictionaries;
    const action = React.useRef(null);
    const baToggleClasses = bookAdmissionToggleStyles(window._theme);

    React.useEffect(()=>{
        if(!admission.id && admission.mrsaScreen?.code == null && props.dictionaries && props.dictionaries.mrsaScreen && Array.isArray(props.dictionaries.mrsaScreen) && props.dictionaries.mrsaScreen.length > 0){
            let adm = _.cloneDeep(admission);
            adm.mrsaScreen = props.dictionaries.mrsaScreen[0];
            adm.transportType = props.dictionaries.transportType[0];
            setAdmission(adm);
            if(props.onChange && _.isFunction(props.onChange)){
                props.onChange('mrsaScreen', adm.mrsaScreen);
                props.onChange('transportType', adm.transportType);
            }
        }
    }, [props.dictionaries])


    React.useEffect(()=>{
        //prepare to edit
     //   console.log(props.admissionToEdit)
        if(props.admissionToEdit) {
            setAdmission((ad) => {
                return {
                    //...ad,
                    ...props.admissionToEdit
                }
            })
        }


    }, [props.admissionToEdit]);

    const handleChange = (field, value) => {
        let tmpAdmission = {...admission};
        let changes = [];
       // console.log("handleChange", field, value);
        //local changes
        if((field === "lengthOfStay" || field === "patientType")){
            if(value.code === 0 || value === 0) {
                 tmpAdmission['lengthOfStay'] = _.find(dictionaries.lengthOfStay, {code: 0}).code;
                 changes.push(['lengthOfStay', tmpAdmission['lengthOfStay']]);
                 tmpAdmission['patientType'] = _.find(dictionaries.patientType, {code: 0});
                 changes.push(['patientType', _.cloneDeep(tmpAdmission['patientType'])]);
            } else {
                if(field === "lengthOfStay" && tmpAdmission["patientType"] !== ""
                    && tmpAdmission["patientType"]?.hasOwnProperty("code") && tmpAdmission["patientType"].code === 0){
                    tmpAdmission['patientType'] = "";
                    changes.push(['patientType', null]);
                }
                if(field === "patientType" && tmpAdmission["lengthOfStay"] === 0){
                    tmpAdmission['lengthOfStay'] = "";
                    changes.push(['lengthOfStay', null]);
                }
                tmpAdmission[field] = value;
                if(field === "lengthOfStay"){
                    changes.push(["lengthOfStay", value]);
                } else {
                    changes.push([field, value]);
                }
            }
        } else {
            tmpAdmission[field] = value;
            changes.push([field, value]);
        }
        //global changes
        if(props.onChange && _.isFunction(props.onChange)){
            props.onChange('multiChange', changes);
        }
        setAdmission(tmpAdmission);
    }

    return (
        <React.Fragment>

            {dictionaries &&
                <Grid container>
                    <Grid item xs={4} sx={{padding: "10px"}}>
                        <FormControl required sx={{width: "100%"}}>
                            <FormLabel id="admission-basic-information-phone-label"
                                       className={classes.label}>{t("Contact Telephone")}</FormLabel>
                            <TextField id="admission-basic-information-phone"
                                       disabled={props.disabled}
                                       size={"small"}
                                       value={admission.phone} onChange={(ev) => {
                                handleChange('phone', ev.target.value)
                            }}/>
                        </FormControl>
                    </Grid>
                    <Grid item xs={4} sx={{padding: "10px"}}>
                        <FormControl required sx={{width: "100%"}}>
                            <FormLabel id="admission-basic-information-transport-type-label"
                                       className={classes.label}>{t("Transport type")}</FormLabel>
                            <Select
                                labelId="admission-basic-information-transport-type-label"
                                id="admission-basic-information-transport-type"
                                value={admission.transportType}
                                disabled={props.disabled}
                                size={"small"}
                                renderValue={(val) => (val.description)}
                                onChange={(selected) => {
                                    handleChange('transportType', selected.target.value)
                                }}
                            >
                                {dictionaries && dictionaries.transportType && dictionaries.transportType.map(r => {
                                    return (<MenuItem value={r} key={r.code}>{r.description}</MenuItem>)
                                })
                                }
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={4} sx={{padding: "10px"}}>
                        {/*<FormControl sx={{ width: "100%"}}>*/}
                        {/*    <FormLabel id="admission-basic-information-ambulance-transport-type-label" className={classes.label}>{t("Ambulance Transport Type")}</FormLabel>*/}
                        {/*    <RadioGroup*/}
                        {/*        row*/}
                        {/*        aria-labelledby="admission-basic-information-ambulance-transport-type-label"*/}
                        {/*        name="admission-basic-information-ambulance-transport-type"*/}
                        {/*        value={admission.ambulanceTransportType}*/}
                        {/*        onChange={(ev)=>{handleChange("ambulanceTransportType", ev.target.value);}}*/}
                        {/*    >*/}
                        {/*        <FormControlLabel value="hoist" control={<Radio />} checked={admission.ambulanceTransportType == "hoist"} label={t("Hoist")} />*/}
                        {/*        <FormControlLabel value="sitting" control={<Radio />} checked={admission.ambulanceTransportType == "sitting"} label={t("Sitting")} />*/}
                        {/*    </RadioGroup>*/}
                        {/*</FormControl>*/}
                    </Grid>
                    <Grid item xs={4} sx={{padding: "10px"}}>
                        <FormControl required sx={{width: "100%"}}>
                            <FormLabel id="admission-basic-information-priority-label"
                                       className={classes.label}>{t("Priority")}</FormLabel>
                            <Select
                                labelId="admission-basic-information-priority-label"
                                id="admission-basic-information-priority"
                                value={admission.priority}
                                disabled={props.disabled}
                                size={"small"}
                                renderValue={(val) => (val.description)}
                                onChange={(selected) => {
                                    handleChange('priority', selected.target.value)
                                }}
                            >
                                {dictionaries && dictionaries.priority && dictionaries.priority.map(r => {
                                    return (
                                        <MenuItem value={r} key={r.code}>{r.description}</MenuItem>
                                    )
                                })
                                }
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={4} sx={{padding: "10px"}}>
                        <FormControl required sx={{width: "100%"}}>
                            <FormLabel id="admission-basic-information-anaesthetic-type-label"
                                       className={classes.label}>{t("Anaesthetic Type")}</FormLabel>
                            <Select
                                labelId="admission-basic-information-anaesthetic-type-label"
                                id="admission-basic-information-anaesthetic-type"
                                value={admission.anaestheticType}
                                renderValue={(val) => (val.description)}
                                disabled={props.disabled}
                                size={"small"}
                                onChange={(selected) => {
                                    handleChange('anaestheticType', selected.target.value)
                                }}
                            >
                                {dictionaries && dictionaries.anaestheticType && dictionaries.anaestheticType.map(r => {
                                    return (
                                        <MenuItem value={r} key={r.code}>{r.description}</MenuItem>
                                    )
                                })
                                }
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={4} sx={{padding: "10px"}}>
                        <FormControl required sx={{width: "100%"}}>
                            <FormLabel id="admission-basic-information-patient-type-label"
                                       className={classes.label}>{t("Patient type")}</FormLabel>
                            <Select
                                labelId="admission-basic-information-patient-type-label"
                                id="admission-basic-information-patient-type"
                                value={admission.patientType}
                                size={"small"}
                                disabled={props.disabled || props.isBooked}
                                renderValue={(val) => (val.description)}
                                onChange={(selected) => {
                                    handleChange('patientType', selected.target.value)
                                }}
                            >

                                {dictionaries && dictionaries.patientType && dictionaries.patientType.map(r => {
                                    return (
                                        <MenuItem value={r} key={r.code}>{r.description}</MenuItem>
                                    )
                                })
                                }
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={4} sx={{padding: "10px"}}>
                        <FormControl required sx={{width: "100%"}}>
                            <FormLabel id="admission-basic-information-who-could-operate-label"
                                       className={classes.label}>{t("Who could operate on this patient")}</FormLabel>
                            <Select
                                labelId="admission-basic-information-who-could-operate-label"
                                id="admission-basic-information-who-could-operate"
                                value={admission.whoCouldOperate}
                                disabled={props.disabled}
                                size={"small"}
                                renderValue={(val) => (val.description)}
                                onChange={(selected) => {
                                    handleChange('whoCouldOperate', selected.target.value)
                                }}
                            >

                                {dictionaries && dictionaries.whoCouldOperate && dictionaries.whoCouldOperate.map(r => {
                                    return (
                                        <MenuItem value={r} key={r.code}>{r.description}</MenuItem>
                                    )
                                })
                                }
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={8} sx={{padding: "10px"}}>
                        &nbsp;
                    </Grid>
                </Grid>
            }
            <div className={classes.hr}></div>
            <Grid container>
                <Grid item xs={12}  sx={{padding: "10px"}}>
                    <div>
                        {t("Admission Details")}
                    </div>
                    <Table>
                        <TableBody >
                            <TableRow>
                                <TableCell className={classes.noBorder}>
                                    <FormGroup>
                                        <FormControlLabel disabled={props.disabled}
                                                          control={<Checkbox />} id={"admission-basic-information-icu-hdu-bed"}
                                                          label={t("ICU/HDU Bed")} checked={admission.icuHduBed}
                                                          onChange={(ev)=>{handleChange("icuHduBed", ev.target.checked);}}/>
                                    </FormGroup>
                                </TableCell>
                                <TableCell className={classes.noBorder}>
                                    <FormGroup>
                                        <FormControlLabel disabled={props.disabled}
                                                          control={<Checkbox />} id={"admission-basic-information-first-on-list"}
                                                          label={t("First on list")} checked={admission.firstOnList}
                                                          onChange={(ev)=>{handleChange("firstOnList", ev.target.checked);}}/>
                                    </FormGroup>
                                </TableCell>
                                <TableCell className={classes.noBorder}>
                                    <FormControlLabel disabled={props.disabled}
                                                      control={<Checkbox />} id={"admission-basic-information-idd"}
                                                      label={t("IDD")} checked={admission.idd}
                                                      onChange={(ev)=>{
                                                          handleChange("idd", ev.target.checked);
                                                          if(ev.target.checked) handleChange("diabetic", ev.target.checked)
                                                      }}/>
                                </TableCell>
                                <TableCell className={classes.noBorder}>
                                    <FormGroup>
                                        <FormControlLabel disabled={props.disabled}
                                                          control={<Checkbox />} id={"admission-basic-information-diabetic"}
                                                          label={t("Diabetic")} checked={admission.diabetic}
                                                          onChange={(ev)=>{handleChange("diabetic", ev.target.checked);}}/>
                                    </FormGroup>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell className={classes.noBorder}>
                                    <FormGroup>
                                        <FormControlLabel disabled={props.disabled}
                                                          control={<Checkbox />} id={"admission-basic-information-radiology-support"}
                                                          label={t("Radiology Support")} checked={admission.radiologySupport}
                                                          onChange={(ev)=>{handleChange("radiologySupport", ev.target.checked);}}/>
                                    </FormGroup>
                                </TableCell>
                                <TableCell className={classes.noBorder}>
                                    <FormGroup>
                                        <FormControlLabel   disabled={props.disabled}
                                                            control={<Checkbox />} id={"admission-basic-information-last-on-list"}
                                                          label={t("Last on list")} checked={admission.lastOnList}
                                                          onChange={(ev)=>{handleChange("lastOnList", ev.target.checked);}}/>
                                    </FormGroup>
                                </TableCell>
                                <TableCell className={classes.noBorder}>
                                    <FormGroup>
                                        <FormControlLabel disabled={props.disabled}
                                                          control={<Checkbox />} id={"admission-basic-information-patient-to-stop-cont-pill"}
                                                          label={t("Patient to stop cont. pill")} checked={admission.patientToStopContPill}
                                                          onChange={(ev)=>{handleChange("patientToStopContPill", ev.target.checked);}}/>
                                    </FormGroup>
                                </TableCell>
                                <TableCell className={classes.noBorder}>
                                    <FormGroup>
                                        <FormGroup>
                                            <FormControlLabel disabled={props.disabled}
                                                              control={<Checkbox />} id={"admission-basic-information-patient-stop-aspirin"}
                                                              label={t("Patient to stop aspirin")} checked={admission.patientToStopAspirin}
                                                              onChange={(ev)=>{handleChange("patientToStopAspirin", ev.target.checked);}}/>
                                        </FormGroup>
                                    </FormGroup>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell className={classes.noBorder}>
                                    <FormGroup>
                                        <FormControlLabel disabled={props.disabled}
                                                          control={<Checkbox />} id={"admission-basic-information-requires-first-assistant"}
                                                          label={t("Requires First Assistant")} checked={admission.requiresFirstAssistant}
                                                          onChange={(ev)=>{handleChange("requiresFirstAssistant", ev.target.checked);}}/>
                                    </FormGroup>
                                </TableCell>
                                <TableCell className={classes.noBorder}>
                                    <FormGroup>
                                        <FormControlLabel disabled={props.disabled}
                                                          control={<Checkbox />} id={"admission-basic-information-am-list-only"}
                                                          label={t("AM list only")} checked={admission.amListOnly}
                                                          onChange={(ev)=>{handleChange("amListOnly", ev.target.checked);}}/>
                                    </FormGroup>
                                </TableCell>
                                <TableCell rowSpan={2} className={clsx(classes.noBorder, classes.tableSelect)}>
                                    <FormControl sx={{ width: "100%"}}>
                                        <FormLabel id="admission-label-patient_to_stop_warfarin" className={classes.label}>{t("Patient to stop Warfarin")}</FormLabel>
                                        <Select
                                            labelId="admission-label-patient_to_stop_warfarin"
                                            id="select-patient_to_stop_warfarin"
                                            value={admission.patientToStopWafarin}
                                            disabled={props.disabled}
                                            size={"small"}
                                            onChange={(selected)=> {
                                                handleChange('patientToStopWafarin', selected.target.value)
                                            }}
                                        >

                                            {dictionaries && dictionaries.patientToStopWarfarin && dictionaries.patientToStopWarfarin.map(r=>{
                                                return (
                                                    <MenuItem value={r.description} key={r.code}>{r.description}</MenuItem>
                                                )                                            })
                                            }
                                        </Select>
                                    </FormControl>
                                </TableCell>
                                <TableCell className={classes.noBorder}>
                                    <FormGroup>
                                        <FormControlLabel disabled={props.disabled}
                                                          control={<Checkbox />} id={"admission-basic-information-latex-allergy"}
                                                          label={t("Latex Allergy")} checked={admission.latexAllergy}
                                                          onChange={(ev)=>{handleChange("latexAllergy", ev.target.checked);}}/>
                                    </FormGroup>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell className={classes.noBorder}>
                                    <FormGroup>
                                        <FormControlLabel disabled={props.disabled}
                                                          control={<Checkbox />} id={"admission-basic-information-specialist-equipment"}
                                                          label={t("Specialist Equipment")} checked={admission.specialistEquipment}
                                                          onChange={(ev)=>{handleChange("specialistEquipment", ev.target.checked);}}/>
                                    </FormGroup>
                                </TableCell>
                                <TableCell className={classes.noBorder}>
                                    <FormGroup>
                                        <FormControlLabel disabled={props.disabled}
                                                          control={<Checkbox />} id={"admission-basic-information-pacemaker-check"}
                                                          label={t("Pacemaker Check")} checked={admission.pacemakerCheck}
                                                          onChange={(ev)=>{handleChange("pacemakerCheck", ev.target.checked);}}/>
                                    </FormGroup>
                                </TableCell>
                                <TableCell className={classes.noBorder}>
                                    <FormGroup>
                                        <FormControlLabel disabled={props.disabled}
                                                          control={<Checkbox />} id={"admission-basic-information-requires-bariatric-table"}
                                                          label={t("Requires Bariatric table")} checked={admission.requiresBariatricTable}
                                                          onChange={(ev)=>{handleChange("requiresBariatricTable", ev.target.checked);}}/>
                                    </FormGroup>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Grid>
                <Grid item xs={4}  sx={{padding: "10px"}}>
                    <FormControl sx={{ width: "100%"}}>
                        <FormLabel id="admission-basic-information-anti_coagulants-label" className={classes.label}>{t("Anti-Coagulants")}</FormLabel>
                        <Select
                            action={action}
                            labelId="admission-basic-information-anti_coagulants-label"
                            id="admission-basic-information-anti_coagulants"
                            placeholder={t("Anti coagulants")}
                            value={admission.antiCoagulents}
                            disabled={props.disabled}
                            size={"small"}
                            onChange={(selected)=> {
                                handleChange('antiCoagulents', selected.target.value);
                            }}
                        >

                            {dictionaries && dictionaries.antiCoagulants && dictionaries.antiCoagulants.map(r=>{
                                return (
                                    <MenuItem value={r.description} key={r.code}>{r.description}</MenuItem>
                                )})
                            }
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>
            <div className={classes.hr}></div>
            <Grid container>
                <Grid item xs={4} sx={{padding: "10px"}}>
                    <FormControl sx={{ width: "100%"}}>
                        <FormLabel id="admission-basic-information-breach-date18wk-label" className={classes.label}>{t("18 wk Breach Date")}</FormLabel>
                        <DatePicker
                            id="admission-basic-information-breach-date18wk"
                            disabled={props.disabled}
                            value={admission.breachDate18wk}
                            inputFormat={config.defaultDateFormat}
                            size={"small"}
                            onChange={(newValue) => {
                                handleChange('breachDate18wk', newValue);
                            }}
                            renderInput={(params) => <TextField {...params}  size={"small"}/>}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={4} sx={{padding: "10px"}}>
                    <FormControl sx={{ width: "100%"}}>
                        <FormLabel id="admission-basic-information-decision-to-treat-label" className={classes.label}>{t("Decision To Treat")}</FormLabel>
                        <DatePicker
                            id="admission-basic-information-decision-to-treat"
                            disabled={props.disabled}
                            value={admission.decisionToTreat}
                            inputFormat={config.defaultDateFormat}
                            onChange={(newValue) => {
                                handleChange('decisionToTreat', newValue);
                            }}
                            renderInput={(params) => <TextField {...params}   size={"small"}/>}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={4} sx={{padding: "10px"}}>
                    <FormControl sx={{ width: "100%"}}>
                        <FormLabel id="admission-basic-information-length-of-stay-label" className={classes.label}>{t("Length of stay")}</FormLabel>
                        <Select
                            labelId="admission-basic-information-length-of-stay-label"
                            disabled={props.disabled || props.isBooked}
                            id="admission-basic-information-length-of-stay"
                            value={admission.lengthOfStay}
                            size={"small"}
                            onChange={(selected)=> {
                                handleChange('lengthOfStay', selected.target.value);
                            }}
                        >

                            {dictionaries && dictionaries.lengthOfStay && dictionaries.lengthOfStay.map(r=>{
                                return (
                                    <MenuItem value={r.code} key={r.code}>{r.description}</MenuItem>
                                )
                                })
                            }
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sx={{padding: "10px"}}>
                    <div style={{display: "inline-flex", alignItems: "center"}}>
                        <span style={{marginRight: "15px"}}>{t("MRSA screen")}</span>

                        <AgyleToggleButtons
                            classNameRoot={baToggleClasses.baToggle_classNameRootSecond}
                            classNameLabel={baToggleClasses.baToggle_classNameLabel}
                            classNameSelected={baToggleClasses.baToggle_classNameSelected}
                            onChange={(mrsa) => {
                                handleChange('mrsaScreen', mrsa);
                            }}
                            value={admission.mrsaScreen}
                            disabled={props.disabled}
                            size="small"
                            options={dictionaries?.mrsaScreen}
                            minWidth={100}
                        />
                    </div>


                    {/*<ToggleRadioNamed items={dictionaries?.mrsaScreen}*/}
                    {/*                  disabled={props.disabled}*/}
                    {/*                  defaultItemSelected={admission.mrsaScreen} />*/}
                </Grid>
            </Grid>

        </React.Fragment>
    )

}